import * as ng from 'angular';
import { OrganismOverviewController } from '../../../../../organisms/overview/overview';

export class MoleculePanelOverviewHeaderMultiDownloadZoneCsvActionController implements ng.IController {
    public static $inject: string[] = [];

    public OrganismOverview: OrganismOverviewController;

    public abort = () => {
        this.OrganismOverview.overviewModel.activeMassAction = false;
    };

    public submit = () => {
        this.OrganismOverview.submitMassAction({methode: 'downloadZoneCsv'})
            .then((result) => {
                if (result) {
                    this.abort();
                    this.OrganismOverview.overviewLoad();
                }
            }, (e) => {
                console.error('error', e);
            });
    };

}

export class MoleculePanelOverviewHeaderMultiDownloadZoneCsvActionComponent implements ng.IComponentOptions {
    public require = {
        OrganismOverview: '^organismOverview'
    };
    public controller =  MoleculePanelOverviewHeaderMultiDownloadZoneCsvActionController;
    public template = require('./multi-download-zone-csv-action.html');
}
